import type { ReactNode } from 'react';
import { SiteFooter } from '@/layout/SiteFooter';
import { SiteHeader } from '@/layout/SiteHeader';
import { RouteHowItWorks } from '@/components/calculator/RouteHowItWorks';

type AppLayoutProps = {
  children: ReactNode;
  showRouteHowItWorks?: boolean;
  /** When true, content uses max-w-7xl (1280px) for tools that need extra horizontal room. */
  wide?: boolean;
};

export function AppLayout({ children, showRouteHowItWorks = true, wide = false }: AppLayoutProps) {
  return (
    <div className="site-noise relative min-h-screen bg-background text-foreground">
      <SiteHeader />
      <main
        className={`mx-auto flex w-full ${wide ? 'max-w-7xl' : 'max-w-6xl'} flex-col gap-6 px-4 py-8 md:px-6 md:py-10`}
      >
        {children}
        {showRouteHowItWorks ? <RouteHowItWorks /> : null}
      </main>
      <SiteFooter />
    </div>
  );
}
